export default "__VITE_ASSET__DGDhP4ja__"